import React, { useEffect, useState, useCallback } from "react";
import {
  ConnectionStatus,
  IConnectionsReport,
  IConnectionsSearchParams,
  getUserStatisticsResp,
} from "../../Interfaces/connections";
import ConnectionsTable from "../../Tables/SahraConnections/ConnectionsTable";
import { useDebouncer } from "../../Hooks/useDebouncer";
import SimpleTextInput from "../../Components/SimpleTextInput";
import {
  getConnectionsTable,
  getUserStatistics,
} from "../../Requests/connections";
import { toast } from "react-toastify";
import useRequest from "../../Hooks/useRequest";
import { Report } from "../../Interfaces/TableInterfaces";
import { setSahraConnectionsTableFetchDataFlag } from "../../Features/SahraConnections/SahraConnectionsSlice";
import { useAppDispatch } from "../../App/hooks";

interface SahraConnectionsProps {
  initialSearchParam?: IConnectionsSearchParams;
}

const SahraConnections = ({ initialSearchParam }: SahraConnectionsProps) => {
  const [searchParam, setSearchParams] =
    React.useState<IConnectionsSearchParams>({
      ...initialSearchParam,
    } as IConnectionsSearchParams);
  const [searchParamName, setSearchParamName] = useState("");
  const searchPramNameDebounce = useDebouncer(searchParamName, 500);
  const [userStatistics, setUserStatistics] = useState<getUserStatisticsResp>(
    {} as getUserStatisticsResp
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    searchParamChangeHandler("name", searchPramNameDebounce);

    // setSearchParams({...searchParams,name:})
    getUserStatisticsHandler();
    const interval = setInterval(() => {
      getUserStatisticsHandler();
    }, 7000);

    return () => clearInterval(interval);
  }, [searchPramNameDebounce]);

  useEffect(() => {
    fetchAllTables();
  }, [searchParam]);

  const fetchAllTables = () => {
    dispatch(setSahraConnectionsTableFetchDataFlag(true));
  };

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParam, [name]: value });
  };

  const getUserStatisticsHandler = () => {
    // setLoading(true);
    getUserStatistics({})
      .then((resp) => setUserStatistics(resp))
      .catch((e) => toast.error(e.response.data.value));
    // .finally(() => setLoading(false));
  };

  const getTable = (connectionStatus: ConnectionStatus) => {
    return (
      <ConnectionsTable
        connectionStatus={connectionStatus}
        searchParam={searchParam}
      />
    );
  };

  return (
    <div className="w-min mx-auto pt-10 flex flex-col justify-start items-center gap-5">
      {/* {loading ? <FullScreenLoading /> : null} */}
      <div className="h-min w-full flex flex-row justify-between items-center">
        <div className="w-40">
          <SimpleTextInput
            placeholder="نام سرمایه گذار"
            name="name"
            onChange={(name, value) => setSearchParamName(value)}
            value={searchParamName}
          />
        </div>
        <div className="flex flex-row justify-start items-center gap-5 ">
          <div className="flex flex-row justify-start items-center gap-2">
            <div className="whitespace-nowrap">متصل:</div>
            <div>{userStatistics.onlineUserCount}</div>
          </div>
          <div className="flex flex-row justify-start items-center gap-2">
            <div className="whitespace-nowrap">قطع حین اتصال:</div>
            <div>{userStatistics.disconnectedUsercount}</div>
          </div>
        </div>
      </div>
      <>
        {getTable(ConnectionStatus.Online)}
        {getTable(ConnectionStatus.Offline)}
        {getTable(ConnectionStatus.Disconnected)}
      </>
    </div>
  );
};

export default SahraConnections;
